import type { Material } from "@/entities/material";
import type { UseReferentialOptions } from "@/entities/referential";

import { REFERENTIAL_ENDPOINT, useReferential } from "@/entities/referential";

import { getDefectsFromMaterials } from "./referential-materials.helper";

export const useReferentialMaterials = (
  options?: UseReferentialOptions<Material[]>
) => {
  const { data, ...result } = useReferential<Material[]>(
    REFERENTIAL_ENDPOINT.MATERIALS,
    options
  );

  return {
    materials: data ?? [],
    ...result,
  };
};

export const useReferentialMaterialsDefects = () => {
  const { materials, ...result } = useReferentialMaterials();
  const defects = getDefectsFromMaterials(materials);

  return {
    ...result,
    defects,
  };
};
